var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 292,
    viewBox: "0 0 286 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 104C8 50.9807 68.4416 8 143 8C159.56 8 173.34 10.1203 188 14",
    stroke: "#00AAFF",
    strokeWidth: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M270.5 104C270.5 108.142 273.858 111.5 278 111.5C282.142 111.5 285.5 108.142 285.5 104L270.5 104ZM188 21.5C233.563 21.5 270.5 58.4365 270.5 104L285.5 104C285.5 50.1522 241.848 6.5 188 6.49999L188 21.5Z",
    fill: "#00AAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98 201.5C102.142 201.5 105.5 198.142 105.5 194C105.5 189.858 102.142 186.5 98 186.5V201.5ZM98 186.5C77.2893 186.5 60.5 169.711 60.5 149H45.5C45.5 177.995 69.0051 201.5 98 201.5V186.5Z",
    fill: "#00AAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M270.5 194C270.5 198.142 273.858 201.5 278 201.5C282.142 201.5 285.5 198.142 285.5 194L270.5 194ZM188 111.5C233.563 111.5 270.5 148.437 270.5 194L285.5 194C285.5 140.152 241.848 96.5 188 96.5L188 111.5Z",
    fill: "#00AAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M285.5 104C285.5 99.8579 282.142 96.5 278 96.5C273.858 96.5 270.5 99.8579 270.5 104L285.5 104ZM270.5 104C270.5 149.563 233.563 186.5 188 186.5L188 201.5C241.848 201.5 285.5 157.848 285.5 104L270.5 104Z",
    fill: "#00AAFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53 149C28.1472 149 8 128.853 8 104",
    stroke: "#00AAFF",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98 104C98 128.853 77.8528 149 53 149",
    stroke: "black",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M188 201.5C192.142 201.5 195.5 198.142 195.5 194C195.5 189.858 192.142 186.5 188 186.5L188 201.5ZM98 201.5L188 201.5L188 186.5L98 186.5L98 201.5Z",
    fill: "#00AAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M188 111.5C192.142 111.5 195.5 108.142 195.5 104C195.5 99.8579 192.142 96.5 188 96.5V111.5ZM188 96.5L98 96.5V111.5L188 111.5V96.5Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180.5 284C180.5 288.142 183.858 291.5 188 291.5C192.142 291.5 195.5 288.142 195.5 284L180.5 284ZM98 201.5C143.563 201.5 180.5 238.437 180.5 284L195.5 284C195.5 230.152 151.848 186.5 98 186.5L98 201.5Z",
    fill: "#00AAFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M188 21.5C192.142 21.5 195.5 18.1421 195.5 14C195.5 9.85786 192.142 6.5 188 6.5L188 21.5ZM105.5 104C105.5 58.4365 142.437 21.5 188 21.5L188 6.5C134.152 6.5 90.5 50.1522 90.5 104L105.5 104Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M285.5 194C285.5 189.858 282.142 186.5 278 186.5C273.858 186.5 270.5 189.858 270.5 194L285.5 194ZM270.5 194C270.5 214.711 253.711 231.5 233 231.5L233 246.5C261.995 246.5 285.5 222.995 285.5 194L270.5 194Z",
    fill: "#00AAFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M233 246.5C237.142 246.5 240.5 243.142 240.5 239C240.5 234.858 237.142 231.5 233 231.5L233 246.5ZM233 231.5C212.289 231.5 195.5 214.711 195.5 194L180.5 194C180.5 222.995 204.005 246.5 233 246.5L233 231.5Z",
    fill: "#00AAFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M188 104L188 194",
    stroke: "black",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M188 59.5L188 194.5",
    stroke: "black",
    strokeWidth: 15,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.630075e8371ef05d99c50c21e08a2a30.svg";
export { ForwardRef as ReactComponent };